import { NotificationImportantOutlined } from "@mui/icons-material";
import { Divider, IconButton, Skeleton, Tooltip } from "@mui/material";
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, useLocation } from "react-router-dom";
import PlaceholderImage from "../../../assets/placeholder.jpg";
import { Icon } from "@iconify/react";
import globalStyles from "../../../../../../src/styles/globalStyles.module.css";
import { updateProductStatus } from "../../../../../api/product";
import { productSelector } from "../../../../../redux/slices/productSlice";
import RequoteRequestModal from "./RequoteRequestModal";
import styles from "../../../styles/customerStyles.module.css";
import ProductDetailsTooltip from "./ProductDetailsTooltip";
import NewExtraRequestModal from "./NewExtraRequestModal";

export default function ProductCard({
  product,
  handleImageError,
  title,
  longText,
}) {
  const dispatch = useDispatch();
  const location = useLocation();
  const { isLoading, productTabValue } = useSelector(productSelector);

  const [open, setOpen] = React.useState(false);
  const handleOpen = () => setOpen(true);


  return (
    <div
      key={product?._id}
      className="product_card"
      style={{
        height: "400px",
        position: "relative",
        boxShadow:
          "rgb(145 158 171 / 20%) 0px 0px 2px 0px, rgb(145 158 171 / 35%) 0px 12px 24px -4px",
        borderRadius: "5px",
        marginLeft: "15px",
      }}
    >
      {productTabValue !== 2 && product?.requote_request !== 'SENT' && (
        <NewExtraRequestModal
          open={open}
          setOpen={setOpen}
          product={product}
          extraRequest={true}
        />
      )}
      <div style={{ position: "relative", padding: "10px" }}>
        {isLoading || !product ? (
          <Skeleton
            variant="rounded"
            height="180px"
            width="100%"
            sx={{ marginTop: "10px" }}
          />
        ) : (
          <img
            src={
              product?.images?.length > 0
                ? product?.images[0]?.src
                : PlaceholderImage
            }
            onError={handleImageError}
            alt="product"
            style={{
              borderRadius: "8px",
              height: "180px",
              objectFit: "cover",
            }}
            className={`${globalStyles.w_100} ${globalStyles.h_100}`}
          />
        )}
        <div
          style={{
            position: "absolute",
            top: "20px",
            right: "20px",
            padding: "5px 12px",
            borderRadius: "10px",
            color: "white",
            background: "rgba(142, 65, 254, 0.7)",
            display: product.is_new ? "block" : "none",
          }}
        >
          {isLoading || !product ? (
            <Skeleton
              variant="rounded"
              height={20}
              width="100%"
              sx={{ marginTop: "10px" }}
            />
          ) : (
            <small style={{ color: "white", margin: 0 }}> New </small>
          )}
        </div>
      </div>
      {location?.pathname !== "/customer/products" &&
        (isLoading || !product ? (
          <Skeleton
            variant="rounded"
            height={20}
            width="100%"
            sx={{ marginTop: "10px" }}
          />
        ) : (
          <div
            style={{
              marginLeft: "11px",
              display: "flex",
              alignItems: "center",
            }}
          >
            <Icon
              icon="ri:store-2-line"
              width="15"
              height="15"
              style={{ color: "rgb(24, 144, 255)" }}
            />
            <h5
              style={{
                marginLeft: "5px",
                fontSize: "12px",
                fontWeight: 500,
              }}
            >
              {product?.store?.store_name}
            </h5>
          </div>
        ))}
      <div
        style={{
          padding: "0px 10px",
          display: "flex",
          justifyContent: "space-between",
        }}
        className={`${globalStyles.p_relative} ${globalStyles.w_100}`}
      >
        <div
          style={{
            width: "100%",
            overflow: "hidden",
            whiteSpace: "nowrap",
          }}
        >
          {isLoading || !product ? (
            <Skeleton
              variant="rounded"
              height={20}
              width="100%"
              sx={{ marginTop: "10px" }}
            />
          ) : (
            <h5
              style={{
                textOverflow: "ellipsis",
                overflow: "hidden",
              }}
              className={`${globalStyles.font_16} ${globalStyles.deep_dark_gray}`}
            >
              {product.title || "Not available"}
            </h5>
          )}
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <div>
              {isLoading || !product ? (
                <Skeleton
                  variant="rounded"
                  height={20}
                  width="100%"
                  sx={{ marginTop: "10px" }}
                />
              ) : (
                <h6
                  style={{
                    fontSize: "14px",
                    fontWeight: 600,
                  }}
                >
                  Store Price:
                  <b>
                    {product?.variants
                      ? "€" + product?.variants[0].price
                      : " Not Available"}
                  </b>
                </h6>
              )}
              {isLoading || !product ? (
                <Skeleton
                  variant="rounded"
                  height={20}
                  width="100%"
                  sx={{ marginTop: "10px" }}
                />
              ) : (
                <h6
                  style={{
                    fontSize: "14px",
                    fontWeight: 600,
                  }}
                >
                  Quoted Price:
                  <b>
                    {product?.variants?.length > 0 &&
                    product?.status === "accepted"
                      ? ` €${product?.variants[0]?.original_price}`
                      : " N/A"}
                  </b>
                </h6>
              )}
            </div>

            <ProductDetailsTooltip product={product} />
            {product?.variants?.filter(
              (variant) => variant?.acceptance === false
            ).length > 0 && (
              <div>
                <Tooltip
                  componentsProps={{
                    tooltip: {
                      sx: {
                        backgroundColor: "#ffff",
                        maxWidth: "450px",
                        width: "auto",
                        boxShadow:
                          "rgb(145 158 171 / 20%) 0px 0px 2px 0px, rgb(145 158 171 / 35%) 0px 12px 24px -4px",
                        color: "black",
                        fontSize: "13px",
                        fontWeight: 500,
                        padding: "15px",
                        textAlign: "left",
                      },
                    },
                    arrow: {
                      sx: {
                        fontSize: 16,
                        color: "#ffff",
                      },
                    },
                  }}
                  title={
                    <div>
                      <>
                        <h5 style={{ fontSize: "16px" }}>Unable to quote</h5>
                        <Divider />

                        {product?.variants
                          ?.filter((variant) => variant?.acceptance === false)
                          .map((variant, i) => (
                            <div
                              key={variant.variant_id}
                              style={{
                                // marginBottom: "20px",
                                display: "flex",
                                alignItems: "baseline",
                              }}
                            >
                              <span
                                style={{
                                  fontSize: "14px",
                                  fontWeight: 500,
                                }}
                              >
                                {i + 1}.
                              </span>
                              <div style={{ marginLeft: "5px" }}>
                                <h6 style={{ fontWeight: 500 }}>
                                  Variant ID: {variant.variant_id}
                                </h6>
                                <h6 style={{ fontWeight: 500 }}>
                                  Variant Title: {variant.title}
                                </h6>
                              </div>
                            </div>
                          ))}
                      </>
                    </div>
                  }
                  placement="bottom"
                  style={{ color: "tomato" }}
                  arrow
                >
                  <IconButton>
                    <NotificationImportantOutlined />
                  </IconButton>
                </Tooltip>
              </div>
            )}
          </div>
        </div>
      </div>
      {product?.variants?.length > 0 && product.status === "accepted" && (
        <div
          style={{
            display: "flex",
            flexWrap: "wrap",
            padding: "10px",
            marginTop: "10px",
            marginBottom: "40px",
          }}
        >
          {product?.variant_options?.map((variant) => (
            <div
              style={{
                padding: "3px 10px",
                borderRadius: "8px",
                background: "#eee",
                marginRight: "5px",
                marginBottom: "5px",
                textAlign: "center",
                color: "#000",
                width: "auto",
              }}
            >
              <small>{variant?.option}</small>
            </div>
          ))}
        </div>
      )}

      <div
        style={{
          padding: "0px 10px",
          position: "absolute",
          width: "100%",
          textAlign: "center",
          bottom: "10px",
          marginTop: `${product?.variants?.length > 0 ? "0px" : "20px"}`,
        }}
      >
        {product?.status === "accepted" ? (
          isLoading || !product ? (
            <Skeleton
              variant="rounded"
              height={40}
              width="100%"
              sx={{ margin: "" }}
            />
          ) : (
            <Link
              onClick={() => dispatch(updateProductStatus(product._id))}
              to={`${title ? `/admin/products/${product?._id}` : product?._id}`}
              style={{
                marginTop: "0px",
                textAlign: "center",
                color: "rgba(142, 65, 254, 0.7)",
              }}
            >
              View details
            </Link>
          )
        ) : (
          <div>
            {isLoading || !product ? (
              <Skeleton
                variant="rounded"
                height={40}
                width="100%"
                sx={{ margin: "" }}
              />
            ) : (
              <div>
                {product?.status === "failed" ? (
                  <Tooltip
                    componentsProps={{
                      tooltip: {
                        sx: {
                          backgroundColor: "#ffff",
                          maxWidth: "450px",
                          width: "auto",
                          boxShadow:
                            "rgb(145 158 171 / 20%) 0px 0px 2px 0px, rgb(145 158 171 / 35%) 0px 12px 24px -4px",
                          color: "black",
                          fontSize: "13px",
                          fontWeight: 500,
                          padding: "15px",
                          textAlign: "left",
                        },
                      },
                      arrow: {
                        sx: {
                          fontSize: 16,
                          color: "#ffff",
                        },
                      },
                    }}
                    title={
                      <div>
                        <h6 style={{ fontSize: "16px", fontWeight: 600 }}>
                          This product could not be sourced because...
                        </h6>
                        <Divider />
                        {product?.unquotation_reasons?.selected_reasons?.map(
                          (reason, i) => (
                            <p style={{ fontWeight: 500 }}>
                              <strong>{i + 1}. </strong>
                              {reason}
                            </p>
                          )
                        )}

                        {product?.unquotation_reasons?.other_reasons !== "" && (
                          <>
                            <h6 style={{ fontSize: "14px", fontWeight: 600 }}>
                              *Other Reasons
                            </h6>
                            <h6 style={{ lineHeight: 1.5 }}>
                              {product?.unquotation_reasons?.other_reasons}
                            </h6>
                          </>
                        )}
                      </div>
                    }
                    placement="top"
                    arrow
                  >
                    <div
                      style={{
                        background: "#FFCFCF",
                        width: "100%",
                      }}
                      className={styles.fulfillment}
                    >
                      Failed
                    </div>
                  </Tooltip>
                ) : (
                  <Tooltip
                    componentsProps={{
                      tooltip: {
                        sx: {
                          backgroundColor: "#ffff",
                          maxWidth: "210px",
                          boxShadow:
                            "rgb(145 158 171 / 20%) 0px 0px 2px 0px, rgb(145 158 171 / 35%) 0px 12px 24px -4px",
                          color: "black",
                          fontSize: "13px",
                          fontWeight: 500,
                          padding: "15px",
                          textAlign: "left",
                        },
                      },
                      arrow: {
                        sx: {
                          fontSize: 16,
                          color: "#ffff",
                        },
                      },
                    }}
                    title={longText}
                    placement="top"
                    arrow
                  >
                    <div
                      style={{
                        background: "rgba(102, 155, 244, 0.29)",
                        width: "100%",
                        fontSize: "12px",
                        cursor: "pointer",
                        // margin: "auto",
                      }}
                      onClick={handleOpen}
                      className={styles.fulfillment}
                    >
                      Pending
                    </div>
                  </Tooltip>
                )}
              </div>
            )}
          </div>
        )}
      </div>
    </div>
  );
}
